export default __webpack_public_path__ + "static/media/Dhawan.c9f62920.png";